<template>
  <div>
    <div class="">
      <v-speed-dial
        v-model="fab"
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" fab icon :title="$t('actions')" x-small>
            <v-icon v-if="fab" color="pink darken-1">mdi-close</v-icon>
            <span v-else class="svg-icon svg-icon-dark svg-icon-2x">
              <svg
                height="24px"
                version="1.1"
                viewBox="0 0 24 24"
                width="24px"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  fill="none"
                  fill-rule="evenodd"
                  stroke="none"
                  stroke-width="1"
                >
                  <rect height="24" width="24" x="0" y="0" />
                  <circle cx="12" cy="5" fill="#000000" r="2" />
                  <circle cx="12" cy="12" fill="#000000" r="2" />
                  <circle cx="12" cy="19" fill="#000000" r="2" />
                </g>
              </svg>
            </span>
          </v-btn>
        </template>
        <v-btn
          v-for="(item, index) in meta.buttons"
          v-show="item.condition ? validation(item) : true"
          :key="index"
          v-status="item.status"
          :class="classBtn + item.class"
          :title="item.label"
          fab
          small
          @click="item.action(data, item.name)"
        >
          <i :class="iconClass + item.icon"></i>
        </v-btn>
      </v-speed-dial>
    </div>
  </div>
</template>

<script>
export default {
  name: "buttons",
  props: {
    data: {},
    action: {
      type: Function,
    },
    meta: {
      type: Object,
    },
  },
  data() {
    return {
      classBtn: "btn btn-sm text-center ",
      iconClass: "px-1 text-center fa fa-",
      direction: "right",
      color: {
        edit: "warning",
        delete: "error",
        show: "info",
        refresh: "indigo",
      },
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-x-reverse-transition",
    };
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },
  methods: {
    validation(item) {
      if (this.data.payment) {
        return item.condition(this.data.payment);
      } else if (this.data.deleted_at) {
        return item.condition(this.data.deleted_at);
      } else if (this.data.provider === "divar_shop") {
        return item.condition("فروشگاه");
      } else if (this.data.data) {
        return item.condition(this.data.data.status || this.data.status);
      } else return true;
    },
  },
};
</script>

<style>
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
</style>
